import { render, staticRenderFns } from "./Caching.vue?vue&type=template&id=36615298&scoped=true"
import script from "./Caching.vue?vue&type=script&lang=js"
export * from "./Caching.vue?vue&type=script&lang=js"
import style0 from "./Caching.vue?vue&type=style&index=0&id=36615298&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36615298",
  null
  
)

export default component.exports